import React, { FC } from "react";
import { CallToActionLink } from "@trussle/external-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { ITextCard } from "../../../types/common";
import { ICTA } from "../../../types/ICTA";
import TextCard from "../../TextCard";
import "./style.scss";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { PanelWrapper } from "../../PanelWrapper";

export interface IVerticalCardsPanelProps {
  titleRichText: IContentfulRichTextResponse;
  cards: ITextCard[];
  callToAction?: ICTA;
  betterV2?: boolean;
  backgroundColour?: string;
}

const VerticalCardsPanel: FC<IVerticalCardsPanelProps> = ({
  titleRichText, cards, callToAction, backgroundColour = "white", betterV2,
}) => (
  <PanelWrapper backgroundColour={backgroundColour} isBetterV2={betterV2} className="wrapper-content">
    <div className="vertical-cards-panel">
      <div className={`vertical-cards-panel__container${betterV2 ? "-v2" : ""}`}>
        <div className="vertical-cards-panel__title">
          {betterV2 ? renderRichText(titleRichText) : <h2>{renderRichText(titleRichText)}</h2>}
        </div>
        <div className={betterV2 ? "vertical-cards-panel__cards-betterV2" : "vertical-cards-panel__cards"}>
          {cards.map((card, idx) => (<TextCard key={card.title} card={card} step={idx + 1} className="vertical-cards-panel-text-card" />))}
        </div>
        {!betterV2 && (
          <div className="vertical-cards-panel__cta">
            {callToAction
              && (
                <CallToActionLink
                  href={callToAction.url}
                  subLabel={callToAction.subtitle as string | undefined}
                >
                  {callToAction.title}
                </CallToActionLink>
              )}
          </div>
        )}
      </div>
    </div>
  </PanelWrapper>
);

export default VerticalCardsPanel;
